import i18n from "../i18n/config";
import { getUserFacingApiMessage } from "./getUserFacingApiMessage";
import { normalizeApiErrorBody, parseKeyValueDataString } from "./apiErrorBody";

export { normalizeApiErrorBody, parseKeyValueDataString } from "./apiErrorBody";

function t(key, options) {
  return i18n.t(key, { ns: "settings", ...options });
}

/**
 * Mensagem completa para falha ao salvar canal (POST/PUT): texto da API + orientação quando houver dados extras.
 */
export function buildChannelSaveErrorMessage(error) {
  const facing = getUserFacingApiMessage(error);
  if (facing?.code && String(facing.code).startsWith("errors.voice.")) {
    return facing.action ? `${facing.message}\n\n${facing.action}` : facing.message;
  }

  const raw = normalizeApiErrorBody(error);
  let serverMessage =
    (typeof raw.message === "string" && raw.message.trim()) ||
    (typeof raw.error === "string" && raw.error.trim()) ||
    null;

  if (typeof serverMessage === "string") {
    if (serverMessage.includes("Column 'id_projeto'")) {
      return t("channelsPage.saveErrorNeedCompany");
    }
    if (serverMessage.includes("Column 'id_tipo'")) {
      return t("channelsPage.saveErrorNeedDefaultType");
    }
  }

  if (raw.code === "DOMAIN_CLAIMED_BY_OTHER_WORKSPACE") {
    const fromObj =
      raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)
        ? raw.data.claimedBy || raw.data.claimed_by
        : null;
    const main = serverMessage || t("channelsPage.saveErrorGeneric");
    if (fromObj) {
      const hint = t("channelsPage.saveErrorEmailDomainClaimedHint", {
        workspace: String(fromObj),
      });
      return `${main}\n\n${hint}`;
    }
    return main;
  }

  const dataStr = typeof raw.data === "string" ? raw.data : "";
  const parsed = parseKeyValueDataString(dataStr);
  const claimedBy = parsed.claimed_by || parsed.claimedBy;

  if (facing?.action && facing?.message) {
    return `${facing.message}\n\n${facing.action}`;
  }

  const main =
    serverMessage || facing?.message || t("channelsPage.saveErrorGeneric");

  if (claimedBy) {
    const hint = t("channelsPage.saveErrorMetaClaimedHint", {
      workspace: claimedBy,
    });
    return `${main}\n\n${hint}`;
  }

  return main;
}

export function twilioSetupIsRegulatoryPending(saveResult) {
  const debug =
    saveResult?.data?.twilioSetupDebug ||
    saveResult?.twilioSetupDebug ||
    null;
  return Boolean(debug?.regulatoryRequired || debug?.skippedPurchase);
}

/**
 * Mensagem única para qualquer falha de API (ex.: DELETE, PUT) quando o backend envia { message } no corpo.
 */
export function getApiErrorDisplayMessage(error, fallbackI18nKey) {
  const facing = getUserFacingApiMessage(error);
  if (facing?.code && String(facing.code).startsWith("errors.")) {
    return facing.action ? `${facing.message}\n\n${facing.action}` : facing.message;
  }
  const raw = normalizeApiErrorBody(error);
  const msg =
    (typeof raw.message === "string" && raw.message.trim()) ||
    (typeof raw.error === "string" && raw.error.trim()) ||
    null;
  if (msg) return msg;
  return t(fallbackI18nKey);
}
